import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  activeFilter,
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";


export type Sop = {
  key: string;
  value: string;
}

const listSops: Source<Sop[]> = {
  graphql: parse(`
    query listIRSOPMasters($nextToken: String) {
      listIRSOPMasters(
        limit: 10000,
        nextToken: $nextToken,
        filter: { isActive: { eq: true } }
      ) {
        nextToken
        items {
          isActive
          key
          value
        }
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.SOPS,
    // The stored partition key is "IRSOP" — the type is IRSOPMaster but the writer
    // (processUploadedMasterData) puts "IRSOP" in modelName, and the dev table agrees.
    // The GraphQL query passes no modelName at all, so AppSync falls back to a full scan;
    // querying the partition is the same set of rows, read directly.
    keyCondition: () => ({
      expression: "#modelName = :modelName",
      names: { "#modelName": "modelName" },
      values: { ":modelName": "IRSOP" },
    }),
    filter: activeFilter,
  },
};

export const getSops = async (client: SchemaClient): Promise<Sop[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listSops);
};

export const getAndProcessSops = async (client: SchemaClient): Promise<Sop[]> => {
  const sops = await getSops(client);
  return sops?.map((sop: Sop) => ({
    key: sop.key,
    value: sop.value
  })) ?? [];
};
